<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="подразделение"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getDepartment"
      :get-list="getItems"
      :can-create-catalog="canEditDepartment()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <department
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Department from "./Department.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "DepartmentSelect",
  components: { Department, CatalogSelect },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getDepartmentSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getDepartment(id) {
      const result = await this.getDepartmentById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditDepartment() {
      return this.hasPermission([PERM.CATALOG_DEPARTMENT_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Departments/DepartmentSelect.vue